// extracted by mini-css-extract-plugin
export var formButtonContainer = "styles-module__formButtonContainer___YZuIz";
export var formContainer = "styles-module__formContainer___soGdz";
export var formSubText = "styles-module__formSubText___GdGvE";
export var giftMobileErrorStyles = "styles-module__giftMobileErrorStyles___QKXMg";
export var updateBillingContainer = "styles-module__updateBillingContainer___Y8MSl";
export var updateBillingCountry = "styles-module__updateBillingCountry____OidW";